import { sanitizeAssistantContent } from 'utils/maggiePresentation'

import { GET, POST } from './api'

const throwIfError = result => {
  if (!result || result?.error) {
    const error = new Error(result?.error?.message || result?.message || 'Maggie is unavailable')
    error.status = result?.error?.status
    throw error
  }
  return result
}

export { sanitizeAssistantContent } from 'utils/maggiePresentation'

export const magChatClient = {
  async getStatus(portal = 'universe', route = '/') {
    const result = await GET(`/mag-chat/status?portal=${encodeURIComponent(portal)}&route=${encodeURIComponent(route)}`, true)
    return result?.available === true
  },

  async sendMessage(input) {
    const result = throwIfError(await POST('/mag-chat/messages', input, true))
    return {
      id: result.requestId,
      requestId: result.requestId,
      conversationId: result.conversationId,
      conversationState: result.conversationState || '',
      conversationSummary: result.conversationSummary || '',
      summarizedThroughMessageId: result.summarizedThroughMessageId || '',
      role: 'assistant',
      content: sanitizeAssistantContent(result.message),
      resourceDiscovery: result.resourceDiscovery ? {
        introduction: sanitizeAssistantContent(result.resourceDiscovery.introduction).slice(0, 500),
        followUp: sanitizeAssistantContent(result.resourceDiscovery.followUp).slice(0, 220),
      } : null,
      outcome: result.outcome,
      action: result.action,
      clarificationAttempt: result.clarificationAttempt,
      conversational: result.conversational === true,
      language: result.language,
      citations: result.sources || result.citations || [],
      createdAt: new Date().toISOString(),
    }
  },

  async sendFeedback(input) {
    return throwIfError(await POST('/mag-chat/feedback', input, true))
  },

  async submitCompetitorFeedback(input) {
    return throwIfError(await POST('/competitive-intelligence/v1/feedback', input, true))
  },

  async getFrontendRelease() {
    try {
      const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
      if (!response.ok) return ''
      const result = await response.json()
      return String(result?.version || '').slice(0, 128)
    } catch (_error) {
      return ''
    }
  },
}
